(function() {
  var TRANSITION = 'transform 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
  var HOVER_ZOOM_SCALE = 2.4;
  var DESKTOP_MQ = '(min-width: 1025px)';
  var LIGHTBOX_MIN_SCALE = 1;
  var LIGHTBOX_MAX_SCALE = 4;
  var LIGHTBOX_TAP_SCALE = 2.5;
  var SWIPE_THRESHOLD = 48;
  var TAP_MOVE_THRESHOLD = 10;

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function getPerView() {
    return window.matchMedia(DESKTOP_MQ).matches ? 2 : 1;
  }

  function isDesktop() {
    return window.matchMedia(DESKTOP_MQ).matches;
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function distance(a, b) {
    var dx = a.x - b.x;
    var dy = a.y - b.y;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function midpoint(a, b) {
    return {
      x: (a.x + b.x) / 2,
      y: (a.y + b.y) / 2
    };
  }

  function touchPoint(touch) {
    return { x: touch.clientX, y: touch.clientY };
  }

  function getLightbox() {
    var lightbox = document.getElementById('product-gallery-dual-lightbox');
    if (lightbox) {
      return lightbox;
    }

    lightbox = document.createElement('div');
    lightbox.id = 'product-gallery-dual-lightbox';
    lightbox.className = 'product-gallery-dual-lightbox';
    lightbox.setAttribute('hidden', '');
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Product image zoom');
    lightbox.innerHTML =
      '<div class="product-gallery-dual-lightbox__backdrop" data-lightbox-close></div>' +
      '<button type="button" class="product-gallery-dual-lightbox__close" data-lightbox-close aria-label="Close">&times;</button>' +
      '<button type="button" class="product-gallery-dual-lightbox__nav product-gallery-dual-lightbox__nav--prev" data-lightbox-prev aria-label="Previous image">&#10094;</button>' +
      '<button type="button" class="product-gallery-dual-lightbox__nav product-gallery-dual-lightbox__nav--next" data-lightbox-next aria-label="Next image">&#10095;</button>' +
      '<div class="product-gallery-dual-lightbox__stage" data-lightbox-stage>' +
      '<img class="product-gallery-dual-lightbox__image" alt="" draggable="false">' +
      '</div>' +
      '<div class="product-gallery-dual-lightbox__controls">' +
      '<button type="button" class="product-gallery-dual-lightbox__zoom-btn" data-lightbox-zoom-out aria-label="Zoom out">&minus;</button>' +
      '<button type="button" class="product-gallery-dual-lightbox__zoom-btn" data-lightbox-zoom-in aria-label="Zoom in">+</button>' +
      '</div>' +
      '<p class="product-gallery-dual-lightbox__hint" data-lightbox-hint>Tap to zoom · Swipe to browse</p>';
    document.body.appendChild(lightbox);
    bindLightboxChrome(lightbox);
    return lightbox;
  }

  function bindLightboxChrome(lightbox) {
    if (lightbox.dataset.chromeBound === 'true') {
      return;
    }
    lightbox.dataset.chromeBound = 'true';

    var stage = lightbox.querySelector('[data-lightbox-stage]');
    var img = lightbox.querySelector('.product-gallery-dual-lightbox__image');
    var hint = lightbox.querySelector('[data-lightbox-hint]');

    var scale = 1;
    var tx = 0;
    var ty = 0;
    var mode = null;
    var startX = 0;
    var startY = 0;
    var startTx = 0;
    var startTy = 0;
    var moved = false;
    var pinchStartDist = 0;
    var pinchStartScale = 1;
    var lastTapTime = 0;

    function isOpen() {
      return lightbox.classList.contains('is-open');
    }

    function applyTransform(withTransition) {
      img.style.transition = withTransition ? 'transform 0.28s ease, opacity 0.2s ease' : 'none';
      img.style.transform = 'translate3d(' + tx + 'px, ' + ty + 'px, 0) scale(' + scale + ')';
      img.style.opacity = '1';
      lightbox.classList.toggle('is-zoomed', scale > 1.01);
      stage.style.cursor = scale > 1.01 ? 'grab' : 'zoom-in';
      if (hint) {
        if (scale > 1.01) {
          hint.textContent = 'Drag to pan · Tap to zoom out';
        } else {
          hint.textContent = lightbox.classList.contains('has-nav')
            ? 'Tap to zoom · Swipe to browse'
            : 'Tap image to zoom in or out';
        }
      }
    }

    function clampPan() {
      if (scale <= 1) {
        tx = 0;
        ty = 0;
        return;
      }
      var displayW = img.clientWidth || img.getBoundingClientRect().width / scale;
      var displayH = img.clientHeight || img.getBoundingClientRect().height / scale;
      var maxX = Math.max(0, (displayW * (scale - 1)) / 2);
      var maxY = Math.max(0, (displayH * (scale - 1)) / 2);
      tx = clamp(tx, -maxX, maxX);
      ty = clamp(ty, -maxY, maxY);
    }

    function resetZoom(withTransition) {
      scale = 1;
      tx = 0;
      ty = 0;
      mode = null;
      applyTransform(!!withTransition);
    }

    function zoomAt(newScale, clientX, clientY, withTransition) {
      newScale = clamp(newScale, LIGHTBOX_MIN_SCALE, LIGHTBOX_MAX_SCALE);
      if (Math.abs(newScale - scale) < 0.01) {
        return;
      }

      var rect = img.getBoundingClientRect();
      var dx = clientX - (rect.left + rect.width / 2);
      var dy = clientY - (rect.top + rect.height / 2);
      var ratio = newScale / scale;

      tx = dx + ratio * (tx - dx);
      ty = dy + ratio * (ty - dy);
      scale = newScale;

      if (scale <= 1.01) {
        scale = 1;
        tx = 0;
        ty = 0;
      } else {
        clampPan();
      }
      applyTransform(withTransition !== false);
    }

    function toggleZoomAt(clientX, clientY) {
      if (scale > 1.05) {
        resetZoom(true);
      } else {
        zoomAt(LIGHTBOX_TAP_SCALE, clientX, clientY, true);
      }
    }

    function stepZoom(direction) {
      var rect = stage.getBoundingClientRect();
      var cx = rect.left + rect.width / 2;
      var cy = rect.top + rect.height / 2;
      zoomAt(scale + direction * 0.5, cx, cy, true);
    }

    lightbox._resetZoom = resetZoom;
    lightbox._applyLightboxTransform = applyTransform;

    lightbox.addEventListener('click', function(e) {
      if (e.target.closest('[data-lightbox-close]')) {
        if (typeof lightbox._dualClose === 'function') {
          lightbox._dualClose();
        }
      } else if (e.target.closest('[data-lightbox-next]')) {
        if (scale > 1.01) {
          resetZoom(true);
          return;
        }
        if (typeof lightbox._dualNext === 'function') {
          lightbox._dualNext();
        }
      } else if (e.target.closest('[data-lightbox-prev]')) {
        if (scale > 1.01) {
          resetZoom(true);
          return;
        }
        if (typeof lightbox._dualPrev === 'function') {
          lightbox._dualPrev();
        }
      } else if (e.target.closest('[data-lightbox-zoom-in]')) {
        stepZoom(1);
      } else if (e.target.closest('[data-lightbox-zoom-out]')) {
        stepZoom(-1);
      }
    });

    document.addEventListener('keydown', function(e) {
      if (!isOpen()) {
        return;
      }
      if (e.key === 'Escape') {
        if (scale > 1.01) {
          resetZoom(true);
          return;
        }
        if (typeof lightbox._dualClose === 'function') {
          lightbox._dualClose();
        }
      } else if (e.key === 'ArrowRight' && scale <= 1.01) {
        if (typeof lightbox._dualNext === 'function') {
          lightbox._dualNext();
        }
      } else if (e.key === 'ArrowLeft' && scale <= 1.01) {
        if (typeof lightbox._dualPrev === 'function') {
          lightbox._dualPrev();
        }
      } else if (e.key === '+' || e.key === '=') {
        stepZoom(1);
      } else if (e.key === '-' || e.key === '_') {
        stepZoom(-1);
      }
    });

    stage.addEventListener('wheel', function(e) {
      if (!isOpen()) {
        return;
      }
      e.preventDefault();
      var delta = e.deltaY > 0 ? -0.25 : 0.25;
      zoomAt(scale + delta, e.clientX, e.clientY, false);
    }, { passive: false });

    stage.addEventListener('pointerdown', function(e) {
      if (!isOpen() || e.button !== 0) {
        return;
      }
      if (e.pointerType === 'touch') {
        return;
      }
      mode = scale > 1.01 ? 'pan' : 'swipe';
      startX = e.clientX;
      startY = e.clientY;
      startTx = tx;
      startTy = ty;
      moved = false;
      img.style.transition = 'none';
      stage.setPointerCapture(e.pointerId);
    });

    stage.addEventListener('pointermove', function(e) {
      if (!mode || e.pointerType === 'touch') {
        return;
      }
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (Math.abs(dx) > TAP_MOVE_THRESHOLD || Math.abs(dy) > TAP_MOVE_THRESHOLD) {
        moved = true;
      }
      if (mode === 'pan') {
        tx = startTx + dx;
        ty = startTy + dy;
        clampPan();
        applyTransform(false);
      } else if (mode === 'swipe' && Math.abs(dx) > Math.abs(dy)) {
        img.style.transform = 'translate3d(' + dx + 'px, 0, 0) scale(1)';
        img.style.opacity = String(Math.max(0.4, 1 - Math.abs(dx) / 360));
      }
    });

    stage.addEventListener('pointerup', function(e) {
      if (e.pointerType === 'touch' || !mode) {
        return;
      }
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      var wasMode = mode;
      mode = null;

      if (!moved) {
        toggleZoomAt(e.clientX, e.clientY);
        return;
      }

      if (wasMode === 'swipe') {
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > SWIPE_THRESHOLD) {
          if (dx < 0 && typeof lightbox._dualNext === 'function') {
            lightbox._dualNext();
          } else if (dx > 0 && typeof lightbox._dualPrev === 'function') {
            lightbox._dualPrev();
          } else {
            applyTransform(true);
          }
        } else {
          applyTransform(true);
        }
      } else {
        clampPan();
        applyTransform(true);
      }
    });

    stage.addEventListener('pointercancel', function() {
      mode = null;
      if (scale <= 1) {
        applyTransform(true);
      } else {
        clampPan();
        applyTransform(true);
      }
    });

    stage.addEventListener('touchstart', function(e) {
      if (!isOpen()) {
        return;
      }
      if (e.touches.length === 2) {
        mode = 'pinch';
        pinchStartDist = distance(touchPoint(e.touches[0]), touchPoint(e.touches[1]));
        pinchStartScale = scale;
        moved = true;
        img.style.transition = 'none';
        return;
      }
      if (e.touches.length === 1) {
        mode = scale > 1.01 ? 'pan' : 'swipe';
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        startTx = tx;
        startTy = ty;
        moved = false;
        img.style.transition = 'none';
      }
    }, { passive: true });

    stage.addEventListener('touchmove', function(e) {
      if (!isOpen() || !mode) {
        return;
      }
      if (mode === 'pinch' && e.touches.length === 2) {
        var mid = midpoint(touchPoint(e.touches[0]), touchPoint(e.touches[1]));
        var dist = distance(touchPoint(e.touches[0]), touchPoint(e.touches[1]));
        if (pinchStartDist > 0) {
          zoomAt(pinchStartScale * (dist / pinchStartDist), mid.x, mid.y, false);
        }
        return;
      }
      if (e.touches.length !== 1) {
        return;
      }
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      if (Math.abs(dx) > TAP_MOVE_THRESHOLD || Math.abs(dy) > TAP_MOVE_THRESHOLD) {
        moved = true;
      }
      if (mode === 'pan') {
        tx = startTx + dx;
        ty = startTy + dy;
        clampPan();
        applyTransform(false);
      } else if (mode === 'swipe' && Math.abs(dx) > Math.abs(dy)) {
        img.style.transform = 'translate3d(' + dx + 'px, 0, 0) scale(1)';
        img.style.opacity = String(Math.max(0.4, 1 - Math.abs(dx) / 360));
      }
    }, { passive: true });

    stage.addEventListener('touchend', function(e) {
      if (!isOpen()) {
        return;
      }

      if (mode === 'pinch') {
        if (e.touches.length === 0) {
          mode = null;
          if (scale < 1.05) {
            resetZoom(true);
          } else {
            clampPan();
            applyTransform(true);
          }
        }
        return;
      }

      if (e.touches.length > 0) {
        return;
      }

      var wasMode = mode;
      var endX = e.changedTouches[0] ? e.changedTouches[0].clientX : startX;
      var endY = e.changedTouches[0] ? e.changedTouches[0].clientY : startY;
      var dx = endX - startX;
      var dy = endY - startY;
      mode = null;

      if (!moved) {
        var now = Date.now();
        // Single tap zooms; rapid second tap also toggles (same handler)
        lastTapTime = now;
        toggleZoomAt(endX, endY);
        return;
      }

      if (wasMode === 'swipe') {
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > SWIPE_THRESHOLD) {
          if (dx < 0 && typeof lightbox._dualNext === 'function') {
            lightbox._dualNext();
          } else if (dx > 0 && typeof lightbox._dualPrev === 'function') {
            lightbox._dualPrev();
          } else {
            applyTransform(true);
          }
        } else {
          applyTransform(true);
        }
      } else {
        clampPan();
        applyTransform(true);
      }
    });

    stage.addEventListener('touchcancel', function() {
      mode = null;
      if (scale <= 1) {
        applyTransform(true);
      } else {
        clampPan();
        applyTransform(true);
      }
    });

    resetZoom(false);
  }

  function initHoverZoom(wrapper) {
    var img = wrapper.querySelector('img');
    var lens = wrapper.querySelector('[data-js-product-gallery-dual-zoom-lens]');
    if (!img || !lens) {
      return;
    }

    var zoomSrc = img.getAttribute('data-zoom-src') || img.currentSrc || img.src;
    var active = false;

    function showLens() {
      if (!isDesktop()) {
        return;
      }
      active = true;
      lens.style.backgroundImage = 'url("' + zoomSrc + '")';
      lens.classList.add('is-visible');
      wrapper.classList.add('is-zooming');
    }

    function hideLens() {
      active = false;
      lens.classList.remove('is-visible');
      wrapper.classList.remove('is-zooming');
    }

    function moveLens(e) {
      if (!active || !isDesktop()) {
        return;
      }

      var rect = wrapper.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      x = Math.max(0, Math.min(100, x));
      y = Math.max(0, Math.min(100, y));

      lens.style.backgroundPosition = x + '% ' + y + '%';
      lens.style.backgroundSize = (HOVER_ZOOM_SCALE * 100) + '%';
    }

    wrapper.addEventListener('mouseenter', showLens);
    wrapper.addEventListener('mouseleave', hideLens);
    wrapper.addEventListener('mousemove', moveLens);
  }

  function initLightbox(gallery, slides, getActiveIndex) {
    var enableFullscreen = gallery.getAttribute('data-fullscreen') === 'true';
    var enableZoom = gallery.getAttribute('data-zoom') === 'true';
    if (!enableFullscreen && !enableZoom) {
      return;
    }

    var fullscreenBtn = gallery.querySelector('[data-js-product-gallery-btn-fullscreen]');
    var imageSlides = slides.filter(function(slide) {
      return slide.getAttribute('data-media-type') === 'image' || slide.querySelector('[data-zoom-src]');
    });

    if (!imageSlides.length) {
      return;
    }

    var lightbox = getLightbox();
    var lightboxImg = lightbox.querySelector('.product-gallery-dual-lightbox__image');
    var hint = lightbox.querySelector('[data-lightbox-hint]');
    var currentIndex = 0;
    var open = false;

    function imageSources() {
      return imageSlides.map(function(slide) {
        var sourceImg = slide.querySelector('img[data-zoom-src], img');
        if (!sourceImg) {
          return null;
        }
        return {
          src: sourceImg.getAttribute('data-zoom-src') || sourceImg.currentSrc || sourceImg.src,
          alt: sourceImg.getAttribute('alt') || ''
        };
      }).filter(Boolean);
    }

    function render(animateDirection) {
      var sources = imageSources();
      if (!sources.length) {
        return;
      }
      currentIndex = Math.max(0, Math.min(currentIndex, sources.length - 1));
      lightboxImg.src = sources[currentIndex].src;
      lightboxImg.alt = sources[currentIndex].alt;
      lightbox.classList.toggle('has-nav', sources.length > 1);
      if (typeof lightbox._resetZoom === 'function') {
        lightbox._resetZoom(false);
      }
      if (hint) {
        hint.hidden = false;
      }

      if (animateDirection && typeof lightbox._resetZoom === 'function') {
        lightboxImg.style.transition = 'none';
        lightboxImg.style.opacity = '0.35';
        lightboxImg.style.transform = 'translate3d(' + (animateDirection === 'next' ? 40 : -40) + 'px, 0, 0) scale(1)';
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            lightbox._resetZoom(true);
          });
        });
      }
    }

    function openLightbox(startIndex) {
      var sources = imageSources();
      if (!sources.length) {
        return;
      }

      if (typeof startIndex === 'number') {
        currentIndex = startIndex;
      } else {
        var activeSlide = slides[getActiveIndex()] || slides[0];
        var mapped = imageSlides.indexOf(activeSlide);
        currentIndex = mapped >= 0 ? mapped : 0;
      }

      render();
      lightbox.removeAttribute('hidden');
      lightbox.classList.add('is-open');
      document.documentElement.classList.add('product-gallery-dual-lightbox-open');
      open = true;
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('hidden', '');
      document.documentElement.classList.remove('product-gallery-dual-lightbox-open');
      open = false;
      if (typeof lightbox._resetZoom === 'function') {
        lightbox._resetZoom(false);
      }
    }

    function next() {
      var sources = imageSources();
      if (sources.length < 2) {
        return;
      }
      currentIndex = (currentIndex + 1) % sources.length;
      render('next');
    }

    function prev() {
      var sources = imageSources();
      if (sources.length < 2) {
        return;
      }
      currentIndex = (currentIndex - 1 + sources.length) % sources.length;
      render('prev');
    }

    function bindTapToOpen(slide, index) {
      var zoomWrap = slide.querySelector('[data-js-product-gallery-dual-zoom]');
      if (!zoomWrap) {
        return;
      }

      zoomWrap.classList.add('product-page-gallery__dual-zoom--tappable');
      zoomWrap.setAttribute('role', 'button');
      zoomWrap.setAttribute('tabindex', '0');
      zoomWrap.setAttribute('aria-label', 'Zoom image');

      var pointerStartX = 0;
      var pointerStartY = 0;
      var pointerMoved = false;

      function openFromSlide() {
        var mapped = imageSlides.indexOf(slide);
        openLightbox(mapped >= 0 ? mapped : index);
      }

      zoomWrap.addEventListener('pointerdown', function(e) {
        if (e.pointerType === 'mouse' && e.button !== 0) {
          return;
        }
        pointerStartX = e.clientX;
        pointerStartY = e.clientY;
        pointerMoved = false;
      });

      zoomWrap.addEventListener('pointermove', function(e) {
        if (Math.abs(e.clientX - pointerStartX) > TAP_MOVE_THRESHOLD || Math.abs(e.clientY - pointerStartY) > TAP_MOVE_THRESHOLD) {
          pointerMoved = true;
        }
      });

      zoomWrap.addEventListener('pointerup', function(e) {
        if (pointerMoved) {
          return;
        }
        if (e.pointerType === 'mouse' && e.button !== 0) {
          return;
        }
        e.preventDefault();
        openFromSlide();
      });

      zoomWrap.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openFromSlide();
        }
      });
    }

    if (fullscreenBtn) {
      fullscreenBtn.addEventListener('click', function(e) {
        e.preventDefault();
        openLightbox();
      });
      fullscreenBtn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openLightbox();
        }
      });
    }

    slides.forEach(bindTapToOpen);

    lightbox._dualClose = closeLightbox;
    lightbox._dualNext = next;
    lightbox._dualPrev = prev;
  }

  function initGallery(gallery) {
    if (!gallery || gallery.dataset.dualInitialized === 'true') {
      return;
    }

    gallery.dataset.dualInitialized = 'true';

    var track = gallery.querySelector('[data-js-product-gallery-dual-main]');
    var viewport = gallery.querySelector('.product-page-gallery__dual-main');
    var slides = toArray(track.querySelectorAll('.product-page-gallery__dual-slide'));
    var prevBtn = gallery.querySelector('[data-js-product-gallery-dual-prev]');
    var nextBtn = gallery.querySelector('[data-js-product-gallery-dual-next]');
    var thumbs = toArray(gallery.querySelectorAll('[data-js-product-gallery-dual-thumb]'));

    if (!track || !viewport || !slides.length) {
      return;
    }

    var slideCount = slides.length;
    var current = parseInt(gallery.getAttribute('data-active-image'), 10) || 0;
    var activeThumb = current;

    function getMaxIndex() {
      return Math.max(0, slideCount - getPerView());
    }

    function getSlideWidth() {
      return viewport.clientWidth / getPerView();
    }

    function setActiveThumb(index) {
      activeThumb = index;
      thumbs.forEach(function(thumb) {
        var thumbIndex = parseInt(thumb.getAttribute('data-index'), 10);
        thumb.classList.toggle('active', thumbIndex === index);
      });
    }

    function layout(skipTransition) {
      var slideWidth = getSlideWidth();

      if (slideWidth <= 0) {
        return;
      }

      track.style.width = (slideWidth * slideCount) + 'px';

      slides.forEach(function(slide) {
        slide.style.flex = '0 0 ' + slideWidth + 'px';
        slide.style.width = slideWidth + 'px';
        slide.style.maxWidth = slideWidth + 'px';
      });

      goTo(current, !skipTransition);
    }

    function goTo(index, animate) {
      var maxIndex = getMaxIndex();
      var slideWidth = getSlideWidth();

      if (slideWidth <= 0) {
        return;
      }

      current = Math.min(Math.max(0, index), maxIndex);
      var offset = current * slideWidth;

      track.style.transition = animate ? TRANSITION : 'none';
      track.style.transform = 'translate3d(-' + offset + 'px, 0, 0)';

      if (!thumbs.length || activeThumb < current || activeThumb > current + getPerView() - 1) {
        setActiveThumb(current);
      }

      gallery.setAttribute('data-active-image', current);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(current - 1);
        setActiveThumb(current);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(current + 1);
        setActiveThumb(current);
      });
    }

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        var index = parseInt(thumb.getAttribute('data-index'), 10) || 0;
        var target = Math.min(index, getMaxIndex());
        goTo(target);
        setActiveThumb(index);
      });
    });

    var touchStartX = 0;
    var touchDeltaX = 0;

    viewport.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchDeltaX = 0;
      track.style.transition = 'none';
    }, { passive: true });

    viewport.addEventListener('touchmove', function(e) {
      touchDeltaX = e.touches[0].clientX - touchStartX;
      var slideWidth = getSlideWidth();
      var baseOffset = current * slideWidth;
      track.style.transform = 'translate3d(-' + (baseOffset - touchDeltaX) + 'px, 0, 0)';
    }, { passive: true });

    viewport.addEventListener('touchend', function() {
      if (touchDeltaX > 50) {
        goTo(current - 1);
      } else if (touchDeltaX < -50) {
        goTo(current + 1);
      } else {
        goTo(current);
      }
      setActiveThumb(current);
    });

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        layout(false);
      }, 120);
    });

    layout(true);
    window.addEventListener('load', function() {
      layout(true);
    });

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function() {
        layout(true);
      });
      ro.observe(viewport);
    }

    if (gallery.getAttribute('data-zoom') === 'true') {
      toArray(gallery.querySelectorAll('.product-page-gallery__dual-zoom--enabled')).forEach(initHoverZoom);
    }

    initLightbox(gallery, slides, function() {
      return activeThumb || current;
    });
  }

  function initAll(root) {
    var scope = root || document;
    toArray(scope.querySelectorAll('.product-page-gallery--dual[data-js-product-gallery]')).forEach(initGallery);
  }

  function toElement(target) {
    if (!target) {
      return null;
    }
    return target.jquery ? target[0] : target;
  }

  window.theme = window.theme || {};

  window.theme.ProductGalleryDual = {
    init: function(target) {
      var el = toElement(target);
      if (el && el.matches && el.matches('.product-page-gallery--dual')) {
        initGallery(el);
      } else if (el) {
        toArray(el.querySelectorAll('.product-page-gallery--dual[data-js-product-gallery]')).forEach(initGallery);
      }
    },
    destroy: function(target) {
      var el = toElement(target);
      if (el) {
        delete el.dataset.dualInitialized;
      }
    },
    initAll: function(target) {
      initAll(toElement(target) || document);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e) {
    initAll(e.target);
  });
})();